import React from 'react';
import styled from 'styled-components';
import { darken, transparentize } from 'polished';
import { COLOR, FONT_SIZE, FONT_STACK, RADIUS, SPACING } from '../../../packages/constants';
import { SortDown } from '../../../packages/icons';

export interface SelectMenuButtonProps {
    id: string;
    dataId: string;
    onClick: React.MouseEventHandler;
    chosenItem?: string;
    placeholder?: string;
    disabled?: boolean;
    width?: string;
    minWidth?: string;
    maxWidth?: string;
    invalid?: boolean;
    hasLegacyStyles?: boolean;
}

type StyledSelectMenuButtonProps = Omit<SelectMenuButtonProps, 'dataId'>;

const StyledSelectMenuButton = styled.button<StyledSelectMenuButtonProps>`
    display: inline-flex;
    position: relative;
    width: ${(props) => (props.width ? props.width : '100%')};
    min-width: ${(props) => (props.minWidth ? props.minWidth : 0)};
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'none')};
    margin: 0;
    padding: ${SPACING.SMALL};
    font-family: ${FONT_STACK};
    font-size: ${(props) => (props.hasLegacyStyles ? '13px' : FONT_SIZE.SMALL)};
    line-height: ${(props) => (props.hasLegacyStyles ? '18px' : FONT_SIZE.MEDIUM)};
    background-color: ${(props) => (props.disabled ? darken('0.1', COLOR.PRIMARY.WHITE) : COLOR.PRIMARY.WHITE)};
    color: ${(props) => (props.disabled ? transparentize('0.5', COLOR.PRIMARY.BLACK) : COLOR.PRIMARY.BLACK)};
    border-width: 1px;
    border-style: solid;
    border-color: ${(props) => (props.invalid ? COLOR.PRIMARY.RED : COLOR.MAIN.FORM_FIELD)};
    border-radius: ${(props) => (props.hasLegacyStyles ? 0 : RADIUS.DEFAULT)};
    appearance: none;
    cursor: pointer;
`;

const MenuButtonArrow = styled(SortDown)`
    padding: 2px;
    align-self: center;
    justify-self: flex-end;
    pointer-events: none;
`;

const ButtonText = styled.span`
    flex-grow: 1;
    text-align: left;
    pointer-events: none;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const SelectMenuButton = React.forwardRef<HTMLButtonElement, SelectMenuButtonProps>(
    ({ id, dataId, onClick, disabled, invalid, width, minWidth, maxWidth, chosenItem, placeholder = '' }, ref) => {
        return (
            <StyledSelectMenuButton
                ref={ref}
                id={id}
                data-test-id={dataId}
                onClick={onClick}
                disabled={disabled}
                invalid={invalid}
                width={width}
                minWidth={minWidth}
                maxWidth={maxWidth}
                type={'button'}
            >
                <ButtonText>{chosenItem ? chosenItem : placeholder}</ButtonText>
                <MenuButtonArrow fill={COLOR.MAIN.DARK_GREY} width={'6px'} height={'4px'} />
            </StyledSelectMenuButton>
        );
    },
);
SelectMenuButton.displayName = 'SelectMenuButton';
